const RequestManager = {
  // endPoint: `https://api.siponline.ir`,
  // endPoint: `https://apistaging.siponline.ir`,
  // endPoint: `${process.env.REACT_APP_API_URL}`,

  // endPoint: `https://apidev.siponline.ir`,
  varsion: ``,
  prefix: `/api`,
  controllers: {
    Auth: {
      name: 'auth',
      actions: {
        LoginPostEmail: {
          name: 'LoginPostEmail',
          path: '/SendLoginVerificationCode',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
          successMessage: 'TOAST.SEND_EMAIL_SUCCESSFULLY',
        },
        GetUserDetails: {
          name: 'GetUserDetails',
          path: '/GetUserDetails',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetUsersAdmin: {
          name: 'GetAdminUsers',
          path: '/GetAdminUsers',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        AddUsersAdmin: {
          name: 'RegisterAdmin',
          path: '/RegisterAdmin',
          method: 'post',
          enable_message: true,
          defaul_cach_time: 0,
          additionalHeaders: null,
          successMessage: 'TOAST.REGISTER_SUCCESSFULLY',
        },
        GetUsers: {
          name: 'GetUsers',
          path: '/GetUsers',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        DeActiveUsersAdmin: {
          name: 'UpdateUserActivationStatus',
          path: '/UpdateUserActivationStatus',
          method: 'post',
          enable_message: true,
          successMessage: 'TOAST.DEACTIVE_USER_SUCCESSFULLY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        UpdateUsersAdmin: {
          name: 'UpdateAdminProfile',
          path: '/UpdateAdminProfile',
          method: 'post',
          enable_message: true,
          defaul_cach_time: 0,
          successMessage: 'TOAST.EDIT.USER.SUCCESSFULY',
          additionalHeaders: null,
        },

        LoginPostVerifictionCode: {
          name: 'LoginPostVerifictionCode',
          path: '/LoginUserByVerificationCode',
          method: 'post',
          enable_message: true,
          successMessage: 'TOAST.LOGIN.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        LoginPostPassword: {
          name: 'LoginPostPassword',
          path: '/loginPostPassword',
          method: 'post',
          enable_message: true,
          successMessage: 'TOAST.LOGIN.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        LoginPost: {
          name: 'LoginPost',
          path: '/Login',
          method: 'post',
          enable_message: true,
          successMessage: 'TOAST.LOGIN.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        RequestPasswordRecovery: {
          name: 'RequestPasswordRecovery',
          path: '/requestPasswordReqovery',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        verifictionPasswordRecoveryCode: {
          name: 'verifictionPasswordRecoveryCode',
          path: '/verifictionRecoveryCode',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        RegisterPostEmail: {
          name: 'SendRegistrationVerificationCode',
          path: '/SendRegistrationVerificationCode',
          method: 'post',
          enable_message: false,
          successMessage: 'TOAST.PLEASE_CHECK_YOUR_EMAIL',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        RegisterPostVerifictionCode: {
          name: 'RegisterSipOnline',
          path: '/RegisterSipOnline',
          method: 'post',
          enable_message: true,
          successMessage: 'TOAST.REGISTER_SUCCESSFULLY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        PostWebsite: {
          name: 'PostWebsite',
          path: '/postWebsite',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        ForgotPassword: {
          name: 'ForgotPassword',
          path: '/ForgotPassword',
          method: 'post',
          enable_message: true,
          successMessage: 'TOAST.SEND_VERIFICATION_CODE_TO_YOUR_EMAIL',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        Login: {
          name: 'Login',
          path: '/Login',
          method: 'post',
          enable_message: false,
          successMessage: 'TOAST.LOGIN_SUCCESS',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        LoginUserInTenant: {
          name: 'LoginUserInTenant',
          path: '/LoginUserInTenant',
          method: 'post',
          enable_message: false,
          successMessage: 'TOAST.LOGIN_SUCCESS',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        Registration: {
          name: 'Registration',
          path: '/Registration',
          method: 'post',
          enable_message: true,
          successMessage: 'TOAST.REGISTER_SUCCESSFULLY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        DomainRegistration: {
          name: 'DomainRegistration',
          path: '/DomainRegistration',
          method: 'post',
          enable_message: true,
          successMessage: 'TOAST.YOUR.DOMAIN.ADDED.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        SendResetPasswordEmail: {
          name: 'SendResetPasswordEmail',
          path: '/SendResetPasswordEmail',
          method: 'post',
          enable_message: true,
          successMessage: "MESSAGES.RESET_PASSWORD_SEND_EMAIL_SUCCESS",
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        ResetPassword: {
          name: 'ResetPassword',
          path: '/ResetPassword',
          method: 'post',
          enable_message: true,
          successMessage: "MESSAGES.RESET_PASSWORD_SET_PASSWORD_SUCCESS",
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },
    },
    TeamMember: {
      name: 'TenantMember',
      actions: {
        AddMember: {
          name: 'AddMember',
          path: '',
          method: 'post',
          enable_message: true,
          successMessage: 'TOAST.YUOR.MEMBER.ADDED.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetMembers: {
          name: 'GetMembers',
          path: '/GetTenantMemberList',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        DeleteMember: {
          name: 'DeleteMembers',
          path: '/',
          method: 'delete',
          enable_message: false,
          successMessage: 'TOAST.YOUR.MEMBER.REMOVED.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        UpdateMember: {
          name: 'UpdateMembers',
          path: '',
          method: 'put',
          enable_message: false,
          successMessage: 'TOAST.YOUR.MEMBER.UPDATED.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        /////////---------------------------- new

        SendTenantMemberInvitationEmail: {
          name: 'SendTenantMemberInvitationEmail',
          path: '/SendTenantMemberInvitationEmail',
          method: 'post',
          enable_message: true,
          successMessage: 'TOAST.SENDING_INVITATION.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        GetTenantMemberDetailForDeleteOrToggle: {
          name: 'GetTenantMemberDetailForDeleteOrToggle',
          path: '/GetTenantMemberDetailForDeleteOrToggle',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        IsTenantMemberPreviousSipExtensionAvailable: {
          name: 'IsTenantMemberPreviousSipExtensionAvailable',
          path: '/IsTenantMemberPreviousSipExtensionAvailable',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        GetAvailableInternalPhone: {
          name: 'GetAvailableInternalPhone',
          path: '/GetAvailableInternalPhone',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        ToggleTenantMemberStatus: {
          name: 'ToggleTenantMemberStatus',
          path: '/ToggleTenantMemberStatus',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        GetTenantMemberRegistrationState: {
          name: 'GetTenantMemberRegistrationState',
          path: '/GetTenantMemberRegistrationState',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        SetTenantMemberUserPassword: {
          name: 'SetTenantMemberUserPassword',
          path: '/SetTenantMemberUserPassword',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },
    },

    WebsiteDomain: {
      name: 'WebsiteDomain',
      actions: {
        GetWebsite: {
          name: 'GetWebsite',
          path: '/get',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        UpdateDomainStatus: {
          name: 'UpdateDomainStatus',
          path: '/UpdateDomainStatus',
          method: 'post',
          enable_message: true,
          defaul_cach_time: 0,
          successMessage: 'TOAST.DOMAIN.DEACTIVTE.SUCCESSFULY',
          additionalHeaders: null,
        },
        UpdateDomainAddress: {
          name: 'UpdateDomainAddress',
          path: '/UpdateDomainAddress',
          method: 'put',
          enable_message: true,
          defaul_cach_time: 0,
          successMessage: 'TOAST.DOMAIN.UPDATE.SUCCESSFULY',
          additionalHeaders: null,
        },
        CheckWebsite: {
          name: 'CheckWebsite',
          path: '/IsUnique',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        AddWebsite: {
          name: 'AddWebsite',
          path: '',
          method: 'post',
          enable_message: true,
          successMessage: 'TOAST.YOUR.DOMAIN.ADDED.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        DeleteWebsite: {
          name: 'DeleteWebsite',
          path: '/',
          method: 'delete',
          enable_message: true,
          successMessage: 'TOAST.YOUR.DOMAIN.REMOVED.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GuidScript: {
          name: 'GuidScript',
          path: '/GuidScript/',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetQueueStrategy: {
          name: 'GetQueueStrategy',
          path: '/GetQueueStrategy',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        UpdateQueueStrategy: {
          name: 'UpdateDomainQueueSetting',
          path: '/UpdateDomainQueueSetting',
          method: 'put',
          enable_message: true,
          successMessage: 'TOAST.YUOR.SETTING.UPDATE.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        getWebsiteDomainQueueSetting: {
          name: 'GetWebsiteDomainQueueSetting',
          path: '/GetWebsiteDomainQueueSetting',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        updateDomainName: {
          name: 'UpdateDomainName',
          path: '/UpdateDomainName',
          method: 'put',
          enable_message: true,
          successMessage: 'TOAST.YOUR.DOMAIN.UPDATE.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetTenantWebsiteDomainNameAndIdList: {
          name: 'GetTenantWebsiteDomainNameAndIdList',
          path: '/GetTenantWebsiteDomainNameAndIdList',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        UpdateDomainSettings: {
          name: 'UpdateDomainSettings',
          path: '/UpdateDomainSettings',
          method: 'put',
          enable_message: true,
          successMessage: 'TOAST.YOUR.DOMAIN.UPDATE.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetDomainSettings: {
          name: 'GetDomainSettings',
          path: '/GetDomainSettings',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetSchemaJson: {
          name: 'GetSchemaJson',
          path: '/GetSchemaJson',
          method: 'put',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },


      },
    },

    WebsiteDomainFile: {
      name: 'WebsiteDomainFile',
      actions: {
        InsertDomainFile: {
          name: 'InsertDomainFile',
          path: '/InsertDomainFile',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetDomainFileDownloadUrl: {
          name: 'GetDomainFileDownloadUrl',
          path: '/GetDomainFileDownloadUrl',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetDomainFilesByContentType: {
          name: 'GetDomainFilesByContentType',
          path: '/GetDomainFilesByContentType',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        UpdateDomainFile: {
          name: 'UpdateDomainFile',
          path: '/UpdateDomainFile',
          method: 'put',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        DeleteDomainFile: {
          name: 'DeleteDomainFile',
          path: '/DeleteDomainFile',
          method: 'delete',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetConfirmationDeleteFile: {
          name: 'GetConfirmationDeleteFile',
          path: '/GetConfirmationDeleteFile',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        }
      },
    },

    User: {
      name: 'MyProfile',
      actions: {
        GetProfile: {
          name: 'MyProfile',
          path: '',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        UpdateProfile: {
          name: 'Update',
          path: '/Update',
          method: 'post',
          enable_message: true,
          successMessage: 'TOAST.YOUR.PROFLE.INFO.UPDATED.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        ChangePassword: {
          name: 'ChangePassword',
          path: '/UpdatePassword',
          method: 'post',
          enable_message: false,
          successMessage: 'TOAST.YOUR.PASSWORD.CHANGED.SUCCESSFULY',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },


      },
    },
    UserImage: {
      name: 'UploadFile',
      actions: {
        UploadProfilePicture: {
          name: 'UploadProfilePicture',
          path: '/UploadProfilePicture',
          method: 'post',
          enable_message: false,
          successMessage: 'عکس شما با موفقیت اپلود شد',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetProfilePhoto: {
          name: 'GetProfilePhoto',
          path: '/GetProfilePhoto',
          method: 'get',
          enable_message: false,
          // successMessage: "عکس شما با موفقیت اپلود شد",
          defaul_cach_time: 0,
          additionalHeaders: null,
        },


      },
    },

    CustomerCall: {
      name: 'CustomerCall',
      actions: {
        Search: {
          name: 'Search',
          path: '/Search',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        RecordUrlList: {
          name: 'RecordUrlList',
          path: '/RecordUrlList',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetCallReportDetail: {
          name: 'GetCallReportDetail',
          path: '/GetCallReportDetail',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        GetSummary: {
          name: 'GetSummary',
          path: '/GetSummary',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

      },
    },
    CallQueueReport: {
      name: 'CallQueueReport',
      actions: {
        Search: {
          name: 'Search',
          path: '/Search',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },
    },
    SaleCompany: {
      name: 'SaleCompany',
      actions: {
        GetAllCompany: {
          name: 'GetAllCompany',
          path: '/GetAllCompany',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        Add: {
          name: 'Add',
          path: '',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },
    },

    Wizard: {
      name: 'Wizard',
      actions: {
        UniqWebSite: {
          name: 'UniqWebSite',
          path: '/WebsiteDomain/Isunique',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },
    },

    Role: {
      name: 'Role',
      actions: {
        GetAllRoles: {
          name: 'GetAllRoles',
          path: '/GetAllRoles',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },
    },
    Package: {
      name: 'Package',
      actions: {
        GetPackagesByUserId: {
          name: 'GetPackagesByUserId',
          path: '/GetPackagesByUserId',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        AddPackageForUser: {
          name: 'AddPackageForUser',
          path: '/AddPackageForUser',
          method: 'post',
          enable_message: false,
          // successMessage: "TOAST.THE.PACKAGE.HAS.BEEN.SUCCESSFULY.FOR.YOU",
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetPackagesType: {
          name: 'GetPackagesType',
          path: '/GetPackagesType',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        UpdatePackageForUser: {
          name: 'UpdatePackageForUser',
          path: '/UpdatePackageForUser',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetPackagesTypeById: {
          name: 'GetPackagesTypeById',
          path: '/GetPackagesTypeById',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetUpgradablePackages: {
          name: 'GetUpgradablePackages',
          path: '/GetUpgradablePackages',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetPackageServiceId: {
          name: 'GetPackageServiceId',
          path: '/GetPackageServiceId',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetClientProduct: {
          name: 'GetClientProduct',
          path: '/GetClientProduct',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },
    },
    Transaction: {
      name: 'Transaction',
      actions: {
        Transaction: {
          name: 'Transaction',
          path: '',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        TransactionPDF: {
          name: 'Transaction',
          path: '',
          method: 'get',
          enable_message: true,
          defaul_cach_time: 0,
          additionalHeaders: null,
          successMessage: 'TOAST.DOWNLOAD.PDF.OF.FACTOR.SUCCESSFULY',
        },
        TransactionAdmin: {
          name: 'Transaction',
          path: '/GetList',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
          // successMessage: "TOAST.TRANSACTION.SUCCESSFULY",
        },
      },
    },
    chat: {
      name: 'chat',
      actions: {
        GetSessionId: {
          name: 'GetSessionId',
          path: '/GetSessionId',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          errorMessage: "",

        },
      }
    },
    WhmcsProduct: {
      name: 'WhmcsProduct',
      actions: {
        InvoiceDetail: {
          name: 'GetInvoice',
          path: '/GetInvoice',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          errorMessage: 'TOAST.GET_INVOICE.ERROR',
        },
        GetUserInvoices: {
          name: 'GetUserInvoices',
          path: '/GetUserInvoices',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },
    },
    APIRunner: {
      name: 'APIRunner',
      actions: {
        GetTicketApiRunner: {
          name: 'GetTicketApiRunner',
          path: '/GetTicketApiRunner',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        OpenTicketApiRunner: {
          name: 'OpenTicketApiRunner',
          path: '/OpenTicketApiRunner',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        TestApiRunner: {
          name: 'ApiRunner',
          path: '/ApiRunner',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          successReplayMessage: 'TOAST.TICKET_REPLAY_SUCCESS',
          errorReplayMessage: 'TOAST.TICKET_REPLAY_ERROR',
          successCreateTicketMessage: 'TOAST.ADD_TICKET_SUCCESS',
          errorCreateTicketMessage: 'TOAST.ADD_TICKET_ERROR',
        },
      },
    },
    TenantMember: {
      name: 'TenantMember',
      actions: {
        InsertNewTenantMember: {
          name: 'InsertNewTenantMember',
          path: '/InsertNewTenantMember',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: "TOAST.INSERT.SUCCESS_TENANT"
        },
        GetAvailableInternalPhone: {
          name: 'GetAvailableInternalPhone',
          path: '/GetAvailableInternalPhone',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        UpdateTenantMember: {
          name: 'UpdateTenantMember',
          path: '/UpdateTenantMember',
          method: 'put',
          defaul_cach_time: 0,
          enable_message: true,
          additionalHeaders: null,
          successMessage: "TOAST.UPDATE.SUCCESS_TENANT"
        },
        GetTenantMemberForUpdate: {
          name: 'GetTenantMemberForUpdate',
          path: '/GetTenantMemberForUpdate',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        deleteTenantMember: {
          name: 'delete',
          path: '/',
          method: 'delete',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: "DELETE_SOFT_TENANT_MEMBER_SUCCESS"
        },
        GetTenantMemberSoftPhoneDetail: {
          name: 'GetTenantMemberSoftPhoneDetail',
          path: '/GetTenantMemberSoftPhoneDetail',
          method: 'get',
          defaul_cach_time: 0,
          enable_message: false,
          additionalHeaders: null,
        },
        SendSoftPhoneDetailToTenantMemberEmail: {
          name: 'SendSoftPhoneDetailToTenantMemberEmail',
          path: '/SendSoftPhoneDetailToTenantMemberEmail',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: "RESEND_SOFT_PHONE_DETAILS_SUCCESS"
        },
        ToggleTenantMemberStatus: {
          name: 'ToggleTenantMemberStatus',
          path: '/ToggleTenantMemberStatus',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: "DELETE_SOFT_TENANT_MEMBER_SUCCESS"
        },
        GetActiveTenantMemberList: {
          name: 'GetActiveTenantMemberList',
          path: '/GetActiveTenantMemberList',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          // enable_message: true,
          // successMessage: "TOAST.INSERT.SUCCESS_TENANT"
        },


      }
    },
    SiteShortLink: {
      name: 'SiteShortLink',
      actions: {
        GetByShortLink: {
          name: 'GetByShortLink',
          path: '/GetByShortLink',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

      },
    },

    UploadFile: {
      name: 'UploadFile',
      actions: {
        UploadPhotoFile: {
          name: 'UploadPhotoFile',
          path: '/UploadPhotoFile',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        UploadVoiceFile: {
          name: 'UploadVoiceFile',
          path: '/UploadVoiceFile',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,


        },
      },

    },
  }

}

export default RequestManager

export const getRequestRequirement = (path) => {

  let resPath = ''
  let action = {}
  const splitedPath = path.split('.')
  const controller = RequestManager.controllers
  if (controller[splitedPath[0]]) {
    resPath = controller[splitedPath[0]].name
    const actions = controller[splitedPath[0]].actions
    if (actions[splitedPath[1]]) {
      action = actions[splitedPath[1]]
      resPath += actions[splitedPath[1]].path
    }
  }
  return { path: resPath, action }
}
